import makeStyles from "@mui/styles/makeStyles";
import logo from "../../assets/logo.png";
import { TITLE } from "../../core/consts";
import Card from "@mui/material/Card";
import { PropsWithChildren } from "react";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 30
    },
    card: {
        width: 500,
        padding: 20
    },
    text: {
        display: 'block',
        textAlign: 'center',
        marginBottom: 15
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 10,
        marginBottom: 20,
        backgroundColor: '#19b3cb'
    },
    logo: {
        width: 60
    },
    title: {
        color: "#ffffff",
        fontSize: 16,
        fontWeight: 700
    }
});

const InfoCard = (props: PropsWithChildren) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Card variant="outlined" className={classes.card}>
                <div className={classes.header}>
                    <a href="/" className={classes.logo}><img src={logo} title={TITLE} alt={TITLE} /></a>
                    <span className={classes.title}>{TITLE}</span>
                </div>
                {props.children}
            </Card>
        </div>
    );
};
export default InfoCard;
